<template>
  <input-widget type="select2" :attribute="attribute" :items="items" :search-handler="handler"
                :options="options" :hint="hint" :model="model" :label="label"
                @select2Select="onSelect"
                @select2Unselect="onUnselect"
                :value-field="valueField" :rules="rules"
                :display-field="displayField ? displayField : computedDisplayField"/>
</template>


<script>
  import InputWidget from "../components/input-widget/InputWidget";
  import BiddersService from "../../modules/bidders/BiddersService";

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "BidderSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      auctionUuid: {
        type: String,
        default: null
      },
      valueField: {
        type: String,
        default: null
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      options: {
        type: Object,
        default: () => {
          return {};
        }
      },
      saleNo: {
        type: String,
        default: null,
      },
      lotUuid: {
        type: String,
        default: null,
      },
      isSearch: {
        type: Boolean,
        default: false,
      },
      rules: {
        type: [String, Object],
        default: null,
        required: false
      },
      displayField: {
        type: [String, Function],
        default: null
      },
    },
    methods: {
      handler(name) {
        let params = {
          paddle_number: name
        };

        if (this.auctionUuid) {
          params.auction_uuid = this.auctionUuid;
        }
        if (this.saleNo) {
          params.sale_no = this.saleNo;
        }
        if (this.lotUuid) {
          params.lot_uuid = this.lotUuid;
        }

        return BiddersService.getBidders(params, 'customer');
      },
      updateItems() {
        if (this.items.length) {
          return;
        }
        const uuid = this.attribute.substr(this.attribute.length - 5, 5);
        if (uuid === '_uuid') {
          let toListenAttribute = this.attribute.substr(0, this.attribute.length - 5);
          if (this.model[toListenAttribute]) {
            this.items.push(this.model[toListenAttribute]);
          }

          this.$watch(`model.${this.attribute}`, function () {
            if (this.model[toListenAttribute] && this.model[toListenAttribute].uuid === this.model[this.attribute]) {
              this.items.push(this.model[toListenAttribute]);
            } else if (!this.model[this.attribute]) {
              if (this.isSearch) {
                this.items.splice(0, this.items.length);
              } else {
                this.items.length = 0;
              }
            }
          }, {deep: true});
        }
      },
      onSelect(data) {
        this.$emit('select', data);
      },
      onUnselect() {
        this.$emit('unselect');
      },
      computedDisplayField(item) {
        if (this.auctionUuid && this.attribute === 'paddle_number') {
          return item.paddle_number + ' - ' + item.customer.display_name;
        }
        else if (item.customer) {
          return item.customer.display_name + ' - ' + item.customer.email;
        }
        else {
          return undefined;
        }
      },
    },
    mounted() {
      this.updateItems();
    }
  }
</script>

<style scoped>

</style>
